import { useState, useEffect } from "react";
import { ChangeAlertCallbackType } from "../../../Root";

export const useCouponsForm = (open: boolean, changeAlert: ChangeAlertCallbackType) => {

    const [isValidForm, setIsValidForm] = useState<boolean>(true);
    const [fileName, setFileName ] = useState<string>()
    const [form, setForm ] = useState({
		partner_uuid: "",
		campaing_uuid: "",
		description: "",
		life_cycle: {sdate: "", edate: ""},
		coupons: "",
	})

	const onHandleChange = (field, field2, e) => {
		let f = form 
		if(field && !field2){
			f[field] = e.target.value
		}
		if(field2){
			f[field][field2] = new Date(e.target.value).toJSON()
		}
		setForm(JSON.parse(JSON.stringify(f)));
        validateForm(f);
	}

    const onSelectFile = (e) => {
        let csv = e.target.files[0];
		if(csv.type !== "text/csv"){
			changeAlert(true, 'error', "Error: El tipo de archivo permitido es CSV");
		} else {
			let reader = new FileReader();
			
			if(csv){
				setFileName(csv.name);
				reader.readAsDataURL(csv);
				reader.onload = ((binding) => {
					return async () => {
						let parts = reader.result.toString().split(',')[1];
						setForm({ ...form, coupons: parts });
						validateForm({ ...form, coupons: parts });
					}}
				)(this);
			}
		}
	}

    const validateForm = (f) => {
        if (f["partner_uuid"] && f["campaing_uuid"] && f["description"] && f["life_cycle"]["sdate"] && f["life_cycle"]["edate"] && f["coupons"]) {
          setIsValidForm(false);
        } else {
          setIsValidForm(true);
        }
    };

    useEffect(() => {
		if(!open){
			setForm(JSON.parse(JSON.stringify({
				partner_uuid: "",
				campaing_uuid: "",
				description: "",
				life_cycle: {sdate: "", edate: ""},
				coupons: "",
			})));
			setFileName("");
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
    }, [open])

    return { form, fileName, onHandleChange, onSelectFile, isValidForm }
}